<template>
  <div class="application" @click="hideSearch">
    <template v-if="isNotPublicAccess">
      <element-header ref="mainHeader"></element-header>
    </template>

    <transition name="fade">
      <router-view :key="$route.fullPath"></router-view>
    </transition>
  </div>
</template>

<script>
import Header from "./components/partials/Header";

export default {
  data() {
    return {};
  },
  components: {
    elementHeader: Header
  },
  beforeMount: function() {
    this.$store.dispatch("GET_HOLIDAYS");
  },
  computed: {
    isNotPublicAccess: function() {
      return -1 === this.$helpers.publicAccess.indexOf(this.$route.name);
    }
  },
  methods: {
    hideSearch: function(element) {
      let elementName = element.target.name;
      if (this.$refs.mainHeader && elementName !== "searchvalue") {
        this.$refs.mainHeader.search = "";
      }
    }
  }
};
</script>